import React from 'react'

const HeaderLeftArea: React.FC<{
  className?: string
}> = ({ className, children }) => {
  return (
    <div className={className}>
      <div className="mr-4">{children}</div>
    </div>
  )
}

export { HeaderLeftArea }
